import React from 'react'
import { css } from '@emotion/react'
import mediaQueries from '../../layout/media-queries'

const productDomain = process.env.GATSBY_PRODUCT_WEBSITE_URL_FOR_FOOTER

const copyrightCss = (theme) => css`
  margin: 0 auto;
  max-width: ${theme.maxWidth};
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: ${theme.colors.jumbo};
  padding: 24px 0;
  line-height: 18px;
  flex-direction: column;

  > p {
    margin: 0;
  }

  > div {
    > p > a {
      color: ${theme.colors.jumbo};
      font-weight: 500;

      text-decoration: none;

      :visited {
        text-decoration: none;
      }

      :hover {
        text-decoration: underline;
      }
    }

    :first-of-type {
      padding-top: 1.5rem;
    }

    :nth-of-type(2) {
      ${mediaQueries.smallScreen()} {
        max-width: 352px;
      }
    }
  }
`

const Copyright = () => {
  const year = new Date().getFullYear()

  return (
    <div css={copyrightCss}>
      <p>
        Copyright &copy;
        {year} Text, Inc. All rights reserved
      </p>
      <div>
        <p>
          We use cookies and similar technologies to enhance your interactions
          with our website and Services, including when you reach out to us on
          chat. This comprises traffic analysis, delivering personalized
          content, and supporting our marketing efforts. By accessing our
          website, interacting with our Services, you agree to let us and our
          partners employ cookies and related technologies on your computer or
          devices. Click the{' '}
          <a href={`${productDomain}/legal/cookies-policy/`}>
            Cookies&nbsp;Policy
          </a>{' '}
          to check how you can control the use of cookies through your device.
          To understand how we process your data, including through cookies, and
          interactions with us, please read our{' '}
          <a href={`${productDomain}/legal/privacy-policy/`}>
            Privacy&nbsp;Policy
          </a>
          .
        </p>
      </div>
    </div>
  )
}

export default Copyright
